import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import { Container, Row, Col } from 'react-grid-system'
import moment from 'moment-timezone'

import { LoadingBoxList } from 'components/LoadingSpinner'

import EditButton from 'components/buttons/EditButton'
import DeleteButton from 'components/buttons/DeleteButton'

import styles from './index.css'

@withRouter
export default class BreakReportList extends React.Component {
  
  static propTypes = {
    loading  : PropTypes.bool,
    entities : PropTypes.arrayOf(PropTypes.object),
    onDelete : PropTypes.func,
    onEdit   : PropTypes.func,
    pageControl: PropTypes.any
  }

  static defaultProps = {
    loading : false,
    onEdit : (id) => {},
    onDelete : (id) => {}
  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Container className={styles.List}>
        <Row className={styles.Header}>
          <Col xs={2}>
            <h1>Name</h1>
          </Col>
          <Col xs={3}>
            <h1>Days since last 24hr break</h1>
          </Col>
          <Col xs={3}>
            <h1>Date of last break</h1>
          </Col>
          <Col xs={4} style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
            {this.props.pageControl}
          </Col>
        </Row>
        {
          this.props.loading && <LoadingBoxList />
        }
        {
          !this.props.loading &&
          (this.props.entities || []).map(({ 
            employee_name,
            days_since_last_24hrs_break,
            date_of_last_break 
          }, i) =>
            <Row className={styles.Row} key={i}>
              <Col xs={2}>
                {employee_name}
              </Col>
              <Col xs={3}>
                {days_since_last_24hrs_break || '-'}
              </Col>
              <Col xs={3}>
                {date_of_last_break || '-'}
              </Col>
              <Col xs={4}>
              </Col>
            </Row>
          )
        }
      </Container>
    )
  }

}



// WEBPACK FOOTER //
// ./src/lists/BreakReportList/index.jsx